<template>
  <img
    v-if="visible"
    class="theme-mascot"
    :src="resource.url"
    :width="resource.width"
    :height="resource.height"
    loading="lazy"
    decoding="async"
    alt=""
    aria-hidden="true"
    @error="setVisible(false)"
  />
</template>

<script>
import ThemeResourceService from "@/services/ThemeResourceService";

export default {
  name: "ThemeMascot",
  data: () => ({ visible: true }),
  computed: {
    resource() {
      return this.$store.getters["ThemeStore/getConfig"]?.mascot?.image || {};
    },
  },
  watch: {
    "resource.url"() {
      this.setVisible(Boolean(ThemeResourceService.safeUrl(this.resource.url)));
    },
  },
  created() {
    this.setVisible(Boolean(ThemeResourceService.safeUrl(this.resource.url)));
  },
  methods: {
    setVisible(visible) {
      this.visible = visible;
      this.$emit("visibility-change", visible);
    },
  },
};
</script>

<style scoped>
.theme-mascot {
  display: block;
  height: 112px;
  -webkit-mask-image: radial-gradient(
    ellipse 82% 84% at 56% 52%,
    #000 54%,
    transparent 100%
  );
  mask-image: radial-gradient(
    ellipse 82% 84% at 56% 52%,
    #000 54%,
    transparent 100%
  );
  object-fit: cover;
  opacity: 0.96;
  width: 112px;
}

@media (max-width: 700px) {
  .theme-mascot {
    display: none;
  }
}
</style>
